import {
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";

export default function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    
    // Create history-like object to maintain backward compatibility
    const history = {
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      location,
      listen: () => {}, // Placeholder for compatibility
    };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        match={{ params }}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}